import AdminListPage from "./components/AdminListPage";
export default function ZonList() { return <AdminListPage title="Senarai Zon" endpoint="/admin/zon" />; }
